import { Component, Input } from '@angular/core';
import { HighlightService } from 'src/app/project-display/utils/highlight.service';

@Component({
  selector: '[eic-analyst-project-note]',
  templateUrl: './analyst-project-note.html',
  styleUrl: './analyst-project-note.scss'
})
export class AnalystProjectNote {
  @Input() projectNote:any

listItems: any;
  searchTerm: any;
  
  constructor(public highlightService: HighlightService) {
    
  }

}




/*
      The complication with Project Notes is that  there are three
      different note formates depending on the note type. Add to that
      the variations caused by coping with mobiles...
*/
/*
EICDataStream3ProjectDisplay.directive('noteItem', ['$compile', 'FEATURE_SWITCHES',
  function ($compile, FEATURE_SWITCHES) {

    var ANALYST_OPINION_ENABLED = FEATURE_SWITCHES.ANALYST_OPINION.Enabled;

    var standardNotesTemplate = "\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);'\
        style='vertical-align: top;white-space:nowrap;'>\
         {{::projectNote.noteDate | date:'MMM yyyy'}}\
    </td>\
    <td></td>\
    <td\
      ng-bind-html='projectNote.note | highlightKeywords'\
      ng-class='highlightClass(projectNote.created, projectNote.updated);' >\
    </td>\
    <td style='vertical-align: top;white-space:nowrap;'>\
      <ul class='list-unstyled ' ng-repeat='noteType in projectNote.noteTypes' >\
        <li ng-class='highlightClass(noteType.created, noteType.created);'>\
          {{::noteType.noteType}}\
        </li>\
      </ul>\
    </td><td>\
    </td>\
  ";

    // The member notes template varies the format by adding edit 
    // and delete controls
    var memberNotesTemplate = "\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);'\
        style='vertical-align: top;white-space:nowrap;font-style:italic;'>\
          {{::projectNote.noteDate | date:'MMM yyyy'}}\
    </td>\
    <td>\
      <i class='fa fa-pencil-square-o fa-lg'\
         style='color:blue;cursor:pointer;'\
         ng-click='openUpdateMemberNoteDialog(projectNote);'\
         tooltip='edit this note...'></i>\
    </td>\
    <td >\
      <div ng-class='highlightClass(projectNote.created, projectNote.updated);' \
        style='font-style:italic;'\
        ng-bind-html='projectNote.note | highlightKeywords'>\
      </div>\
      <div style='font-size:11px;'>\
        <span style='font-weight:bold;'>created by:</span> {{::projectNote.createdBy}} {{::projectNote.created | date:'dd MMM yyyy'}} &nbsp;&nbsp;&nbsp;\
        <span ng-if='projectNote.updated > projectNote.created'><span style='font-weight:bold;'>updated by:</span> {{::projectNote.updatedBy}} {{::projectNote.updated | date:'dd MMM yyyy'}}</span>\
      </div>\
    </td>\
    <td style='vertical-align: top;white-space:nowrap;'>\
      <ul class='list-unstyled ' ng-repeat='noteType in projectNote.noteTypes' >\
        <li ng-class='highlightClass(noteType.created, noteType.created);'\
            style='font-style:italic;'>\
            {{::noteType.noteType}}\
        </li>\
      </ul>\
    </td>\
    <td>\
      <i class='fa fa-times-circle fa-lg no-print'\
         style='color:red;margin-top:4px;cursor:pointer;'\
         ng-click='openDeleteMemberNoteDialog(projectNote);'\
         tooltip='delete this note...'\
         tooltip-placement='top'\
         tooltip-append-to-body='true'></i>\
    </td>\
  ";

    // The Analyst Opinion format varies the tmplay to add the words
    // Analyst opinion in bold above the note. There is also the possibilty
    // of adding the job title (such as 'Upstream Analyst' - but this practice
    // seems to have lapsed).
    // The most i9mportant point is that although 'Analyst Opinion' is a 
    // Note Type, it cannot stand alone. It MUST be coupled with a nother note
    // type ot the note will not be displayed
    var analystOpinionTemplate = "\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);'\
       style='vertical-align: top;white-space:nowrap;'>\
         {{::projectNote.noteDate | date:'MMM yyyy'}}\
    </td>\
    <td></td>\
    <td ng-class='highlightClass(projectNote.created, projectNote.updated);' >\
      <div style='font-weight:bold;'>Analyst's opinion ({{projectNote.editorJobTitle}})</div>\
      <div style='margin-left:20px'\
           ng-bind-html='projectNote.note | highlightKeywords'></div>\
    </td>\
    <td style='vertical-align: top;white-space:nowrap;'>\
      <ul class='list-unstyled ' ng-repeat='noteType in projectNote.noteTypes' >\
        <li ng-class='highlightClass(noteType.created, noteType.created);' ng-if='noteType.noteTypeID!=7'>\
          {{::noteType.noteType}}\
        </li>\
      </ul>\
    </td><td>\
    </td>\
  ";

    var getTemplate = function (contentType) {
      var template = '';
      switch (contentType) {
        case 6:        // memberNotes
          template = memberNotesTemplate;
          break;

        case 7:       // analystOpinion
          template = ANALYST_OPINION_ENABLED ? analystOpinionTemplate : standardNotesTemplate;
          break;

        default:        // standardNote
          template = standardNotesTemplate;
          break;
      }
      return template;
    };


    var getContentType = function (projectNote) {
      var contentType = 0;
      projectNote.noteTypes.forEach(
        function (nt) {
          var noteTypeID = nt.noteTypeID;
          if (noteTypeID == 6 || noteTypeID == 7) contentType = noteTypeID;
        });
      return contentType;
      // return projectNote.noteTypes[0].noteTypeID;
    };


    var linker = function (scope, element, attrs) {
      var contentType = getContentType(scope.projectNote);

      element.html(getTemplate(contentType)).show();

      $compile(element.contents())(scope);
    };

    var controller = ['$scope', 'dialogs', 'projectDataService', 'keywordsService',
      function ($scope, dialogs, projectDataService, keywordsService) {

        //-- Project Note Highlight ------------------------------------------------
        var dateDiff = function (startDate, endDate) {
          return ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
        };

        var projectCreatedWithinThreshold = function (dateCreated, dateUpdated, threshold) {
          return (dateDiff(dateCreated, new Date()) < threshold) && (dateUpdated - dateCreated < 5000);
        };

        var projectUpdatedWithinThreshold = function (dateUpdated, threshold) {
          return (dateDiff(dateUpdated, new Date()) < threshold);
        };

        $scope.highlightThreshold = 15;

        $scope.highlightClass = function (created, updated) {
          created = new Date(created);
          updated = new Date(updated);

          if (projectCreatedWithinThreshold(created, updated, $scope.highlightThreshold)) return "created";
          if (projectUpdatedWithinThreshold(updated, $scope.highlightThreshold)) return "updated";

          return "";

        };
        //-- /Project Note Highlight ------------------------------------------------


        //-- Member Notes Dialogs ------------------------------------------------
        $scope.openUpdateMemberNoteDialog = function (memberNote) {
          var dlgUpdateMemberNote = dialogs.create('/app-ds3/memberNotes/updateMemberNoteDialog.html',
            'updateMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );

          dlgUpdateMemberNote.result.then(function (memberNote) {
            // Find the old version of the note and replace it with the new one
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              var projectNote = projectDataService.projectNotes[i];
              var noteTypeID = projectNote.noteTypes[0].noteTypeID;
              if (memberNote.projectNoteID == projectNote.projectNoteID && memberNote.noteTypes[0].noteTypeID == noteTypeID) {
                //projectDataService.projectNotes.splice(i, 1);
                projectDataService.projectNotes.splice(i, 1, memberNote);
                break;
              }
            }
          }, function () {
            // Action upon failure
          });
        }

        $scope.openDeleteMemberNoteDialog = function (memberNote) {
          var dlgDeleteMemberNote = dialogs.create('/app-ds3/memberNotes/deleteMemberNoteDialog.html',
            'deleteMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );

          dlgDeleteMemberNote.result.then(function (deletedMemberNote) {
            // assuming the note was successfully delete, remove it from the project notes array
            // 1. get  the position of the membernote with the given MemberNoteID and the specified text
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              let projectNote = projectDataService.projectNotes[i];
              if (projectNote.projectNoteID == deletedMemberNote.projectNoteID && projectNote.note == deletedMemberNote.note) {
                projectDataService.projectNotes.splice(i, 1);
                break;
              }
            }


          }, function () {
            // Action upon failure
          });


        };
        //-- /Member Notes Dialogs ------------------------------------------------
      }];


    return {
      restrict: "AE",
      link: linker,
      scope: {
        projectNote: '=noteItem'
      },
      controller: controller
    };

  }]);

EICDataStream3ProjectDisplay.directive('mobileNoteItem', ['$compile', 'FEATURE_SWITCHES',
  function ($compile, FEATURE_SWITCHES) {

    var ANALYST_OPINION_ENABLED = FEATURE_SWITCHES.ANALYST_OPINION.Enabled;

    var standardNotesTemplate = `
    <div style='border-top: 1px solid #ddd;padding-bottom:10px'>
      <div style='display:flex' >
        <div ng-class='highlightClass(projectNote.created, projectNote.updated);'
          style='font-weight:bold'>
          {{::projectNote.noteDate | date:'MMM yyyy'}}
        </div>
        <div>
          <ul class='list-unstyled'
              style = 'margin-left:15px; margin-bottom:0'
              ng-repeat='noteType in projectNote.noteTypes'>
            <li ng-class='highlightClass(noteType.created, noteType.created);'>
              {{::noteType.noteType}}
            </li>
          </ul>
        </div>
      </div>
      <div
        ng-bind-html='projectNote.note | highlightKeywords'
        ng-class='highlightClass(projectNote.created, projectNote.updated);' >
      </div>
    </div>
  `;

    // The Analyst Opinion format varies the tmplay to add the words
    // Analyst opinion in bold above the note. There is also the possibilty
    // of adding the job title (such as 'Upstream Analyst' - but this practice
    // seems to have lapsed).
    // The most i9mportant point is that although 'Analyst Opinion' is a 
    // Note Type, it cannot stand alone. It MUST be coupled with a nother note
    // type ot the note will not be displayed
    var memberNotesTemplate = `
    <div style='border-top: 1px solid #ddd;padding-bottom:10px'>
      <div style='display:flex' ng-class='highlightClass(projectNote.created, projectNote.updated);' >
        <div
          style='font-weight:bold'>
          {{::projectNote.noteDate | date:'MMM yyyy'}}
        </div>
        <div>
          <ul class='list-unstyled'
              style = 'margin-left:15px; margin-bottom:0'
              ng-repeat='noteType in projectNote.noteTypes'>
            <li ng-class='highlightClass(noteType.created, noteType.created);'>
              {{::noteType.noteType}}
            </li>
          </ul>
        </div>
      </div>
      <div style='display:flex'>
        <div style='margin-right:10px'>
          <i class='fa fa-pencil-square-o fa-lg'
            style='color:blue;cursor:pointer;'
            ng-click='openUpdateMemberNoteDialog(projectNote);'
            tooltip='edit this note...'></i>
        </div>
        <div>
          <div ng-class='highlightClass(projectNote.created, projectNote.updated);' \
               style='font-style:italic;'
               ng-bind-html='projectNote.note | highlightKeywords'>
          </div>
          <div style='font-size:11px;'>
            <span style='font-weight:bold;'>created by:</span> {{::projectNote.createdBy}} {{::projectNote.created | date:'dd MMM yyyy'}} &nbsp;&nbsp;&nbsp;\
            <span ng-if='projectNote.updated > projectNote.created'><span style='font-weight:bold;'>updated by:</span> {{::projectNote.updatedBy}} {{::projectNote.updated | date:'dd MMM yyyy'}}</span>\
          </div>
        </div>
        <div>
          <i class='fa fa-times-circle fa-lg no-print'
            style='color:red;margin-top:4px;cursor:pointer;'
            ng-click='openDeleteMemberNoteDialog(projectNote);'
            tooltip='delete this note...'
            tooltip-placement='top'
            tooltip-append-to-body='true'></i>
        </div>
      </div>
    </div>
  `;

    var analystOpinionTemplate = `
    <div style='border-top: 1px solid #ddd;padding-bottom:10px'>
      <div style='display:flex' >
        <div ng-class='highlightClass(projectNote.created, projectNote.updated);'
          style='font-weight:bold;white-space:nowrap;margin-right:10px'>
          {{::projectNote.noteDate | date:'MMM yyyy'}}
        </div>
        <div ng-class='highlightClass(projectNote.created, projectNote.updated);' >
          <div style='font-weight:bold;'>Analyst's opinion <span ng-if='projectNote.editorJobTitle'>({{}})</span></div>
         </div>
        <div>
          <ul class='list-unstyled'
              style = 'margin-left:15px; margin-bottom:0'
              ng-repeat='noteType in projectNote.noteTypes'>
            <li ng-class='highlightClass(noteType.created, noteType.created);'
                ng-if= 'noteType.noteTypeID!=7' >
              {{::noteType.noteType}}
            </li>
          </ul>
        </div>
      </div>
      <div
        ng-bind-html='projectNote.note | highlightKeywords'
        ng-class='highlightClass(projectNote.created, projectNote.updated);' >
      </div>
    </div>
  `;


    var getTemplate = function (contentType) {
      var template = '';
      switch (contentType) {
        case 6:        // memberNotes
          template = memberNotesTemplate;
          break;

        case 7:       // analystOpinion
          template = ANALYST_OPINION_ENABLED ? analystOpinionTemplate : standardNotesTemplate;
          break;

        default:        // standardNote
          template = standardNotesTemplate;
          break;
      }
      return template;
    };


    var getContentType = function (projectNote) {
      var contentType = 0;
      projectNote.noteTypes.forEach(
        function (nt) {
          var noteTypeID = nt.noteTypeID;
          if (noteTypeID == 6 || noteTypeID == 7) contentType = noteTypeID;
        });
      return contentType;
      // return projectNote.noteTypes[0].noteTypeID;
    };


    var linker = function (scope, element, attrs) {
      var contentType = getContentType(scope.projectNote);

      element.html(getTemplate(contentType)).show();

      $compile(element.contents())(scope);
    };

    var controller = ['$scope', 'dialogs', 'projectDataService', 'keywordsService',
      function ($scope, dialogs, projectDataService, keywordsService) {

        //-- Project Note Highlight ------------------------------------------------
        var dateDiff = function (startDate, endDate) {
          return ((endDate.getTime() - startDate.getTime()) / 1000 / 60 / 60 / 24);
        };

        var projectCreatedWithinThreshold = function (dateCreated, dateUpdated, threshold) {
          return (dateDiff(dateCreated, new Date()) < threshold) && (dateUpdated - dateCreated < 5000);
        };

        var projectUpdatedWithinThreshold = function (dateUpdated, threshold) {
          return (dateDiff(dateUpdated, new Date()) < threshold);
        };

        $scope.highlightThreshold = 15;

        $scope.highlightClass = function (created, updated) {
          created = new Date(created);
          updated = new Date(updated);

          if (projectCreatedWithinThreshold(created, updated, $scope.highlightThreshold)) return "created";
          if (projectUpdatedWithinThreshold(updated, $scope.highlightThreshold)) return "updated";

          return "";

        };
        //-- /Project Note Highlight ------------------------------------------------


        //-- Member Notes Dialogs ------------------------------------------------
        var setDialogProportionsForMobile = function () {
          const leftBorder = 10;
          const topBorder = 5;
          const dialogWidth = window.innerWidth - (3 * leftBorder);
          $(".modal-dialog").css({
            left: leftBorder,
            top: topBorder,
            width: dialogWidth
          });
          $(".modal-body ").css({
            paddingTop: 2,
            paddingBottom: 2,
          });
          $(".modal-footer ").css({
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 2,
            paddingBottom: 2,
          });
        }
        
        $scope.openUpdateMemberNoteDialog = function (memberNote) {
          var dlgUpdateMemberNote = dialogs.create('/app-ds3/memberNotes/updateMemberNoteDialog.html',
            'updateMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );
          dlgUpdateMemberNote.result.then(function (memberNote) {
            // Find the old version of the note and replace it with the new one
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              var projectNote = projectDataService.projectNotes[i];
              var noteTypeID = projectNote.noteTypes[0].noteTypeID;
              if (memberNote.projectNoteID == projectNote.projectNoteID && memberNote.noteTypes[0].noteTypeID == noteTypeID) {
                //projectDataService.projectNotes.splice(i, 1);
                projectDataService.projectNotes.splice(i, 1, memberNote);
                break;
              }
            }
          }, function () {
            // Action upon failure
          });

          setTimeout(setDialogProportionsForMobile, 200);

         // ensurePositionForMobile();

        }

        $scope.openDeleteMemberNoteDialog = function (memberNote) {
          var dlgDeleteMemberNote = dialogs.create('/app-ds3/memberNotes/deleteMemberNoteDialog.html',
            'deleteMemberNoteDialogCtrl',
            { memberNote: memberNote },
            {
              size: 'md',
              keyboard: true,
              backdrop: 'static',
              windowClass: 'my-class'
            }
          );

          setTimeout(setDialogProportionsForMobile, 200);

          //ensurePositionForMobile();

          dlgDeleteMemberNote.result.then(function (deletedMemberNote) {
            // assuming the note was successfully delete, remove it from the project notes array
            // 1. get  the position of the membernote with the given MemberNoteID and the specified text
            for (var i = 0; i < projectDataService.projectNotes.length; i++) {
              projectNote = projectDataService.projectNotes[i];
              if (projectNote.projectNoteID == deletedMemberNote.projectNoteID && projectNote.note == deletedMemberNote.note) {
                projectDataService.projectNotes.splice(i, 1);
                break;
              }
            }


          }, function () {
            // Action upon failure
          });
        };
        //-- /Member Notes Dialogs ------------------------------------------------

        // var ensurePositionForMobile = function () {
        //   // If we are on a mobile, extra action is needed
        //   // to posiion the dialog correctly. This need to be
        //   // done on the next turn   
        //   if (window.innerWidth < 600) {
        //     setTimeout(function () {
        //       $(".modal-dialog").css({ left: 20 });
        //     }, 200);
        //   };
        // }

      }];


    return {
      restrict: "AE",
      link: linker,
      scope: {
        projectNote: '=mobileNoteItem'
      },
      controller: controller
    };

  }]);
*/